// extracted by mini-css-extract-plugin
export default {"display":"Heading_display__FK7++","text":"Heading_text__LNBRD","subtext":"Heading_subtext__ibGnQ"};